import React from 'react';

import Badge from '@vfgroup-oneplatform/foundation/Components/Badge';
import { BadgeTypes } from '@vfgroup-oneplatform/foundation/Components/Badge/Badge.Utils';
import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { Bill_Status } from '../../Utils/BillStatus.Enum';

function Tag({ status, containerStyle, textStyle }) {
  let statusLabel = '';
  let type = '';
  switch (status) {
    case Bill_Status.SENT:
      statusLabel = 'billing_card_tag_processing_payment';
      type = BadgeTypes.PROCESSING;
      break;
    case Bill_Status.NEW:
      statusLabel = 'billing_card_tag_unpaid';
      type = BadgeTypes.NEUTRAL;
      break;
    case Bill_Status.PARTIALLY_PAID:
      statusLabel = 'billing_card_tag_partially_paid';
      type = BadgeTypes.NEUTRAL;
      break;
    case Bill_Status.SETTLED:
      statusLabel = 'billing_card_tag_paid';
      type = BadgeTypes.POSITIVE;
      break;
    case Bill_Status.OVERDUE:
      statusLabel = 'billing_card_tag_overdue';
      type = BadgeTypes.CRITICAL;
      break;
    default:
      break;
  }
  return <Badge type={type} text={statusLabel} style={containerStyle} textStyle={textStyle} />;
}

Tag.defaultProps = {
  containerStyle: {},
  textStyle: {},
};

Tag.propTypes = {
  status: PropTypes.oneOf(['sent', 'partiallyPaid', 'settled', 'overdue', 'new']),
  containerStyle: ViewPropTypes.style,
  textStyle: TextPropTypes.style,
};

export default Tag;
